import { useEffect, useState } from 'react';

import { getDaysInMonth, isValid, lightFormat } from 'date-fns';

import { UseDateValuesProps, UseDateValuesReturn } from '../types';

export const useDateValues = (
  props: UseDateValuesProps
): UseDateValuesReturn => {
  const { value, shouldHideDayInput, setValue } = props;
  const date = new Date(value);
  const [dayValue, setDayValue] = useState(
    value ? `${date.getUTCDate()}`.padStart(2, '0') : ''
  );
  const [monthValue, setMonthValue] = useState(
    value ? `${date.getUTCMonth() + 1}`.padStart(2, '0') : ''
  );
  const [yearValue, setYearValue] = useState(
    value ? `${date.getUTCFullYear()}` : ''
  );

  useEffect(() => {
    let newDate = '';
    if (shouldHideDayInput && !dayValue) {
      setDayValue('01');
    }

    if (yearValue) {
      if (yearValue.length > 4) return setYearValue(yearValue.slice(0, 4));
    }

    if (monthValue) {
      if (monthValue.length > 2) return setMonthValue(monthValue.slice(0, 2));
      if (Number(monthValue) > 12) return setMonthValue('12');
    }

    if (dayValue) {
      if (dayValue.length > 2) return setDayValue(dayValue.slice(0, 2));
      const year = Number(yearValue) || new Date().getFullYear();
      const month = (Number(monthValue) || 0) - 1;
      const maxDay = getDaysInMonth(new Date(year, month));
      if (Number(dayValue) > maxDay) return setDayValue(String(maxDay));
    }

    if (dayValue && monthValue && yearValue) {
      const dateDraft = new Date(
        yearValue +
          '-' +
          `0${monthValue}`.slice(-2) +
          '-' +
          `0${dayValue}`.slice(-2) +
          'T12:00:00Z'
      );

      if (isValid(dateDraft)) {
        newDate = lightFormat(dateDraft, 'yyyy-MM-dd');
      }
    }

    if (newDate === '' && value === null) {
      return;
    }

    if (newDate !== value) {
      setValue(newDate);
    }
  }, [dayValue, monthValue, yearValue, value, shouldHideDayInput]);

  return {
    dayValue,
    setDayValue,
    monthValue,
    setMonthValue,
    yearValue,
    setYearValue,
  };
};
